// To do:
// - 
// 

import React, { useState, useEffect, useCallback } from 'react';
import { Paragraph, Tab, Tabs, Box, Text } from 'grommet';
import { PageHeader, Page, PageContent } from 'grommet';
import { MapTabContent } from '../../components/MapTabContent';
import { ReferencesComp } from './references/ReferencesComp';
import { useLocation, useNavigate } from 'react-router-dom';
import './page.css';

export const HoHHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabTitles = ['vision', 'summary', 'references', 'discover'];

  const getTabIdFromUrl = useCallback(() => {
    const match = location.pathname.match(/\/hoh\/([a-z-]+)/);
    return match ? match[1] : 'vision';
  }, [location.pathname]);

  const [activeLatestTab, setActiveLatestTab] = useState(getTabIdFromUrl);

  // Sync state with URL when the location changes
  useEffect(() => {
    const tabIdFromUrl = getTabIdFromUrl();
    setActiveLatestTab(tabIdFromUrl);
  }, [getTabIdFromUrl]);

  // Update the browser URL when the tab changes
  useEffect(() => {
    navigate(`/hoh/${activeLatestTab.toLowerCase()}`);
  }, [activeLatestTab, navigate]);

  const activeTabIndex = tabTitles.indexOf(activeLatestTab);

  return (
    <Page flex="grow" background="background">
      <Box
        background="url('/images/satin-1.jpg')"
        height={{ min: '140px', max: 'auto' }}
        margin={{ top: 'none' }}
        pad={{ bottom: 'small' }}
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <Box margin={{ top: 'none', left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={
              <Text color="white" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>
                Welcome to the home of HPE-on-HPE
              </Text>
            }
            subtitle={'Being customer gold and our own best reference'}
            style={{ color: 'white' }}
            size="medium"
          />
        </Box>
      </Box>

      <PageContent flex="grow" background="background" width="80%">
        <Tabs
          activeIndex={activeTabIndex}
          onActive={(index) => setActiveLatestTab(tabTitles[index])}
          justify="start"
          pad={{ top: 'medium' }}
        >
          <Tab title="Vision">
            <MapTabContent>
              <Paragraph margin="none">Vision coming soon!</Paragraph>
            </MapTabContent>          
          </Tab>
          <Tab title="Summary">
            <MapTabContent>
              <Paragraph margin="none">Summary coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Content">
            <ReferencesComp />
          </Tab>
          <Tab title="Discover">
            <MapTabContent>
              <Paragraph margin="none">Discover coming soon!</Paragraph>
            </MapTabContent>
          </Tab>          
        </Tabs>
      </PageContent>
    </Page>
  );
};